import { apiFetch } from "./client";

export interface MemoryShareEntry {
  readerAgentId: string;
  readerName: string;
  readerRole: string | null;
  grantedAt: string;
  grantedByUserId: string | null;
  grantedByEmail: string | null;
  grantedByName: string | null;
}

export interface AgentMemoryAccessState {
  enabled: boolean;
  memoryAdminRead: boolean;
  memoryShared: boolean;
  shares: MemoryShareEntry[];
}

export interface MemoryAccessToggles {
  enabled?: boolean;
  memoryAdminRead?: boolean;
  memoryShared?: boolean;
}

export interface MemoryAccessUpdateResult {
  enabled: boolean;
  memoryAdminRead: boolean;
  memoryShared: boolean;
  sync?: { synced: boolean; restarted: boolean; error?: string };
}

export const agentMemoryAccessApi = {
  get: (companyId: string, agentId: string) =>
    apiFetch<AgentMemoryAccessState>(
      `/companies/${companyId}/agents/${agentId}/memory-access`,
    ),

  update: (companyId: string, agentId: string, data: MemoryAccessToggles) =>
    apiFetch<MemoryAccessUpdateResult>(
      `/companies/${companyId}/agents/${agentId}/memory-access`,
      { method: "PUT", body: JSON.stringify(data) },
    ),

  grantShare: (companyId: string, agentId: string, readerAgentId: string) =>
    apiFetch<{ ownerAgentId: string; readerAgentId: string }>(
      `/companies/${companyId}/agents/${agentId}/memory-access/shares`,
      { method: "POST", body: JSON.stringify({ readerAgentId }) },
    ),

  revokeShare: (companyId: string, agentId: string, readerAgentId: string) =>
    apiFetch<void>(
      `/companies/${companyId}/agents/${agentId}/memory-access/shares/${readerAgentId}`,
      { method: "DELETE" },
    ),
};
